// Welke oplevering draait hier? Getoond op het welkomstscherm, zodat je na een
// push naar main in één oogopslag ziet of de live-omgeving al mee is.
//
// De waarden komen uit de BUILD (Dockerfile, stage 1): CRA bakt process.env.
// REACT_APP_* letterlijk in de bundel, dus ze moeten hier met hun volledige naam
// staan — via een variabele of dynamische sleutel blijven ze leeg.
//   REACT_APP_BUILD_DATE  — moment van de build (UTC, ISO); op Render is dat de
//                           oplevering zelf, hooguit enkele minuten vóór de
//                           live-gang.
//   REACT_APP_GIT_COMMIT  — de commit (RENDER_GIT_COMMIT op Render), afgekort.
// Lokaal (dev-server) bestaan ze niet: dan staat er "Ontwikkelversie".
const BUILD_DATE = process.env.REACT_APP_BUILD_DATE || '';
const GIT_COMMIT = process.env.REACT_APP_GIT_COMMIT || '';

// "Versie 16-09-2026 21:14 · 780c3b1" — Brusselse tijd, dag-maand-jaar zoals de
// rest van het portaal. Zonder geldige builddatum: "Ontwikkelversie".
export function versieLabel({ buildDate = BUILD_DATE, commit = GIT_COMMIT } = {}) {
  const d = buildDate ? new Date(buildDate) : null;
  if (!d || Number.isNaN(d.getTime())) return 'Ontwikkelversie';
  const delen = {};
  for (const p of new Intl.DateTimeFormat('nl-BE', {
    timeZone: 'Europe/Brussels', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false,
  }).formatToParts(d)) delen[p.type] = p.value;
  const kort = String(commit || '').trim().slice(0, 7);
  return `Versie ${delen.day}-${delen.month}-${delen.year} ${delen.hour}:${delen.minute}${kort ? ` · ${kort}` : ''}`;
}
